export default __webpack_public_path__ + "static/media/which-track.34ada9ed.png";